import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Core/Button/Button";
import Flex from "../../components/Layout/Flex";
import TableLayout from "../../components/Layout/TableLayout";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import { SalaryBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { DATE_TIME_FORMAT_TYPES } from "../../configs/constants/DateTimeFormatTypes";
import { routes } from "../../configs/constants/routes";
import { useSalaryBatches } from "../../networking/salary.hooks";
import { formatRoute } from "../../utils/route.utils";
import { describeSalaryBatchScope } from "./components/salaryBatchFilter.utils";

const SalaryListPage: React.FC = () => {
	const { salaryBatches, isLoading } = useSalaryBatches();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const navigateToSalaryBatch = (batchId: string) => {
		navigate(formatRoute(routes.SALARY_BATCH_DETAILS, [batchId]));
	};

	const navigateToNewSalaryBatch = () => {
		navigate(routes.SALARY_NEW_BATCH);
	};

	return (
		<>
			<Breadcrumbs items={SalaryBreadcrumbs} />
			<div className="p-4 px-6">
				<Flex justifyContent="flex-end">
					<Button onClick={navigateToNewSalaryBatch}>{t("NEW_SALARY_BATCH")}</Button>
				</Flex>
				{isLoading ? (
					<LoadingIndicator />
				) : (
					<TableLayout>
						<table>
							<thead>
								<tr>
									<th>{t("batchFilter.scopeColumn")}</th>
									<th>{t("STATUS")}</th>
									<th>{t("FROM")}</th>
									<th>{t("TO")}</th>
									<th>{t("CREATED")}</th>
								</tr>
							</thead>
							<tbody>
								{salaryBatches.map((batch) => {
									return (
										<tr key={batch.id} onClick={() => navigateToSalaryBatch(batch.id)}>
											<td>{describeSalaryBatchScope(batch, t)}</td>
											<td>{t(`salaryBatch.status.${batch.status}` as any)}</td>
											<td>{moment(batch.from).format(DATE_TIME_FORMAT_TYPES.DATE)}</td>
											<td>{moment(batch.to).format(DATE_TIME_FORMAT_TYPES.DATE)}</td>
											<td>
												{moment(batch.metadata?.created).format(DATE_TIME_FORMAT_TYPES.DATE_TIME)}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</TableLayout>
				)}
			</div>
		</>
	);
};

export default SalaryListPage;
